export const normalizeError = err => {
  return {
    error: {
      satus: err.response?.status,
      data: err.response?.data.error || err.message,
    },
  };
};
